// Tried installing @types/chrome, but ts-loader needed to be upgraded,
// but then that required upgrading webpack.
declare global {
  interface Window {
    chrome: any;
  }
}

// eslint-disable-next-line max-len, @typescript-eslint/explicit-module-boundary-types
export async function sendMessageToChromeExtension<T>(extensionId: string, payload: any): Promise<T> {
  return new Promise((resolve, reject) => {
    try {
      window.chrome.runtime.sendMessage(
        extensionId,
        payload,
        (response:any) => {
          if (window.chrome.runtime.lastError) {
            reject(window.chrome.runtime.lastError);
          }
          resolve(response);
        },
      );
    } catch (error: any) {
      reject(error);
    }
  });
}
